import { memo, useContext } from 'react'
import styled from 'styled-components'
import logo_Black from 'assets/images/logo_astro_black.svg'
import store from 'storeContext'

function HeadLabel() {
  const {
    state: { dataPOLiteCreatePO },
  } = useContext(store.PrintAreaContext)

  const renderRigtHeader = () => {
    let tag = ''
    if (
      dataPOLiteCreatePO?.booking_type === 'VIP' &&
      dataPOLiteCreatePO?.timeslot_type === 'FCFS_PARENT'
    )
      tag = '| PRIORITY'
    else if (dataPOLiteCreatePO?.booking_type === 'FCFS') tag = '| FCFS'

    return <StyledTitlePage>PURCHASE ORDER {tag}</StyledTitlePage>
  }

  return (
    <Container>
      <ContainerLeft>
        <img src={logo_Black} style={{ width: '150px' }} />
        {renderRigtHeader()}
        {dataPOLiteCreatePO.schedule_type?.toLowerCase() === 'poia' && (
          <StyledPoAdvance>IN ADVANCE</StyledPoAdvance>
        )}
      </ContainerLeft>
      {dataPOLiteCreatePO.qrCodeDataUrl && (
        <img src={dataPOLiteCreatePO.qrCodeDataUrl} style={{ width: '80px', height: '80px' }} />
      )}
    </Container>
  )
}

export default memo(HeadLabel)

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
`

const ContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledTitlePage = styled.p`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 900;
  line-height: 30px;
  letter-spacing: -0.072px;
  margin-top: 8px;
  margin-bottom: 0;
`
const StyledPoAdvance = styled.div`
  display: inline-block;
  border-radius: 4px;
  background-color: black;
  color: #fff;
  font-weight: bold;
  text-transform: none;
  font-size: 18px;
  padding: 2px 8px;
  letter-spacing: 0.5px;
  margin-top: 4px;
`
